export default "__VITE_ASSET__DsWb7wkL__"